import React from 'react';
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import MainSection from '../components/MainSection';
import Banner from '../components/Banner';
import Footer from '../components/Footer';

const Principal = () => {
  return (
    <div>
      <Navbar />
      <Header />
      <MainSection />
      <Banner />
      <Footer />
    </div>
  );
};

export default Principal;
